import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ANNUITY_INTERNAL_STATUSES, AnnuityInternalStatus } from '../../../shared/dto/annuities/annuity-internal-status';
import { NOT_TO_PAY_REASONS, OptNotToPayReason } from '../../../shared/dto/annuities/opt-not-to-pay-reason';

@Component({
  selector: 'townip-annuity-internal-status',
  templateUrl: './annuity-internal-status.component.html',
  styleUrls: ['./annuity-internal-status.component.scss']
})
export class AnnuityInternalStatusComponent implements OnInit, OnChanges {

  @Input()
  public status: AnnuityInternalStatus;

  @Input()
  public optNotToPayReason: OptNotToPayReason;

  @Input()
  public optNotToPayOtherReason: string;

  @Input()
  public fluid = false;

  public readableStatus: string;

  constructor() { }

  public ngOnInit(): void { }

  public ngOnChanges(changes: SimpleChanges): void {
    this.parseStatus();
  }

  private parseStatus(): void {
    try {
      const statusMatch = ANNUITY_INTERNAL_STATUSES.find((option) => option.value === this.status);
      this.readableStatus = statusMatch ? statusMatch.label : this.status;

      if (this.status !== AnnuityInternalStatus.OptNotToPay) {
        return;
      }

      if (this.optNotToPayReason === OptNotToPayReason.Other && this.optNotToPayOtherReason) {
        this.readableStatus += ' - Other';
      } else {
        const reasonMatch = NOT_TO_PAY_REASONS.find(option => option.value === this.optNotToPayReason);
        this.readableStatus += ` - ${reasonMatch ? reasonMatch.label : this.optNotToPayReason}`;
      }
    } catch (e) {
      this.readableStatus = this.status;
    }
  }

}
